export const STORE_PAGE_LIST = "STORE_PAGE_LIST";
export const STORE_PAGE_DELETE = "STORE_PAGE_DELETE";
export const STORE_PAGE_DELETES = "STORE_PAGE_DELETES";
